/* Shows the back in stock form when the variant picker lands on a sold out
   variant, and hides it again when it does not.

   It watches the add to cart button rather than subscribing to the theme's
   variant event, because the button is the one thing every Dawn version
   updates on a variant change and its wording is already localised. A button
   can also read "Unavailable" for a combination that does not exist at all;
   asking to be told when that comes back would be nonsense, so only the
   sold out wording opens the form. */
(function () {
  function init() {
    var box = document.querySelector('[data-notify]');
    if (!box) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    var button = form && form.querySelector('button[name="add"]');
    if (!button) return;

    var soldOutText = (box.dataset.soldOutText || '').trim().toLowerCase();
    var variantLabel = box.querySelector('[data-notify-variant]');
    var fieldVariant = box.querySelector('[data-notify-field-variant]');
    var fieldUrl = box.querySelector('[data-notify-field-url]');
    var fieldBody = box.querySelector('[data-notify-field-body]');
    var productTitle = fieldBody ? fieldBody.dataset.productTitle || '' : '';

    function currentVariantTitle() {
      /* The picker prints the chosen value next to each option name. Reading
         it back is exact and needs no variant table in the page.

         Keyed by option name because the theme swaps this markup wholesale on
         a variant change, and for a moment the old labels and the new ones are
         both in the document. Taking the last value seen for each name keeps
         the freshest one and cannot produce "Meadow / 2X / Meadow / 2X". */
      var byName = {};
      var order = [];
      document.querySelectorAll('.product-form__input .form__label').forEach(function (label) {
        var whole = (label.textContent || '').replace(/\s+/g, ' ').trim();
        var colon = whole.indexOf(':');
        if (colon < 0) return;
        var name = whole.slice(0, colon).trim();
        var value = label.querySelector('span, .form__label-value');
        var text = ((value ? value.textContent : whole.slice(colon + 1)) || '').trim();
        if (!name || !text) return;
        if (!(name in byName)) order.push(name);
        byName[name] = text;
      });
      return order.map(function (n) { return byName[n]; }).join(' / ');
    }

    function sync() {
      var label = (button.textContent || '').trim().toLowerCase();
      var soldOut = button.disabled && soldOutText && label.indexOf(soldOutText) > -1;

      if (!soldOut) {
        box.hidden = true;
        return;
      }

      var title = currentVariantTitle();
      if (title) {
        if (variantLabel) variantLabel.textContent = title;
        if (fieldVariant) fieldVariant.value = title;
        if (fieldBody) {
          fieldBody.value = 'Back in stock request for ' + productTitle + ' in ' + title + '.';
        }
      }
      if (fieldUrl) fieldUrl.value = window.location.href;
      box.hidden = false;
    }

    /* The back in stock form sits inside <product-component>, which listens
       for submit events on the way up and calls preventDefault on all of them
       so the add to cart form can post over fetch instead of navigating. That
       swallowed this form too: it validated, it submitted, and nothing ever
       left the page. Stopping the event at the form keeps the component's
       handler out of it while leaving the add to cart form untouched. */
    box.querySelectorAll('form').forEach(function (f) {
      f.addEventListener('submit', function (e) { e.stopPropagation(); });
    });

    /* The swap fires a burst of mutations; settling first means reading one
       coherent state instead of the half replaced one in the middle. */
    var pending;
    function scheduleSync() {
      clearTimeout(pending);
      pending = setTimeout(sync, 150);
    }

    new MutationObserver(scheduleSync).observe(button, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
